import React from "react";
import { connect } from "react-redux";
import PaypalExpressBtn from "react-paypal-express-checkout";

import { paymentSuccess } from "../../actions/userActions";

const connected = connect(store => {
  return {
  };
})
export class PaypalButton extends React.Component {
  render() {
    const { premiumAmount } = this.props;

    const onSuccess = payment => {
      this.props.dispatch(paymentSuccess(payment));
    };

    const onCancel = data => {
      // User pressed "cancel" or close Paypal's popup!
      console.log("The payment was cancelled!", data);
      // You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
    };

    const onError = err => {
      // The main Paypal's script cannot be loaded or somethings block the loading of that script!
      console.log("Error!", err);
      // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
      // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
    };

    let env = "production"; // you can set here to 'production' for production
    let currency = "USD"; // or you can set this value from your props or state

    const client = {
      sandbox:
        "AaoKUckTip-ExcrlptmKarrQpOek0xDorQqEs9I9VyYoM1ozhNsPa8QZmgp_UEitynINt1Wt4ncWtYeU",
      production:
        "AcqPTM8bCEXwaIc9suZyU33ofPP9LkBXATmMVcqsVireC4QwU7h3eOp4u1-opx0Q-G5LexcUWZbJuyYe"
    };
    // In order to get production's app-ID, you will have to send your app to Paypal for approval first
    // For sandbox app-ID (after logging into your developer account, please locate the "REST API apps" section, click "Create App"):
    //   => https://developer.paypal.com/docs/classic/lifecycle/sb_credentials/
    // For production app-ID:
    //   => https://developer.paypal.com/docs/classic/lifecycle/goingLive/

    // NB. You can also have many Paypal express checkout buttons on page, just pass in the correct amount and they will work!
    return (
      <PaypalExpressBtn
        className="PaypalExpressBtn"
        env={env}
        client={client}
        currency={currency}
        total={premiumAmount}
        onError={onError}
        onSuccess={onSuccess}
        onCancel={onCancel}
        shipping={null}
      />
    );
  }
}
export default connected(PaypalButton);
